<template>
    <a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4ODY2MDY1Nw==&scene=124#wechat_redirect">
        <div class="service-btn bg-primary top-53">客服</div>
    </a>
</template>

<script>
  export default {

  }
</script>

<style scoped lang="scss">

</style>
